<template>
  <ModalContainer :show="show" @close="onCancel">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <template slot="header">
      <h4 class="mb-0">{{ $t("add-driver") }}</h4>
    </template>

    <template slot="body">
      <form class="p-2" @submit.prevent="adddriver">
        <div
          style="display: flex; justify-content: space-between;"
          class="driver_form"
        >
          <div class="driver_form_input">
            <div class="form-group">
              <label for="fullname"> {{ $t("driver-name") }}</label>
              <input
                type="text"
                name="name"
                v-model="fullname"
                class="form-control"
                required
                id="receiver-name"
                :placeholder="$t('enter-driver-name')"
                @keypress="isLetter($event)"
              />
            </div>

            <div class="form-group">
              <label for="InputNumber"> {{ $t("phone_num") }}</label>
              <input
                v-model="number"
                type="tel"
                class="form-control"
                required
                id="phone-number"
                :placeholder="$t('enter-num')"
              />
              <p v-if="ErrorPhone" class="my-0 small text-error p-1">
                {{ ErrorPhone }}
              </p>
            </div>
          </div>

          <div class="driver_form_input">
            <div class="form-group">
              <label for="email"> {{ $t("email") }}</label>
              <input
                v-model="email"
                type="text"
                name="name"
                class="form-control"
                required
                id="email"
                :placeholder="$t('enter-mail')"
              />
            </div>

            <div class="form-group">
              <label for="vehicle"> {{ $t("assign_vehicle") }} {{ $t("optional") }} </label>
              <select
                v-model="vehicle"
                name="vehicle"
                class="form-control"
                id="vehicle"
              >
                <option value="" >{{ $t("select-vehicle") }}</option>
                <option
                  v-for="vehicle in vehicles"
                  :key="vehicle.id"
                  :value="vehicle"
                >
                  {{ vehicle.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="address"> {{ $t("address") }}</label>
          <input
            type="text"
            name="address"
            v-model="address"
            class="form-control"
            required
            :placeholder="$t('enter-address')"
          />
        </div>

        <div type="submit" class="btn-add">
          <button>{{ $t("add") }}</button>
        </div>
      </form>
    </template>
  </ModalContainer>
</template>

<script>
import ModalContainer from "../../components/ModalContainer";
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import * as intlTelInput from "../../assets/js/intlTelInput";
import * as utils from "../../assets/js/utils";

export default {
  name: "AddDrivers",
  components: {
    ModalContainer,
    Loading,
  },

  props: {
    show: Boolean,
    onCancel: Function,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      fullname: "",
      email: "",
      address: "",
      number: "",
      mssg: "",
      ErrorPhone: "",
      Errormssg: "",
      iti: "",
      showSuccessPopup: false,
      vehicle: this.vehicle || "",
    };
  },
  mounted() {
    this.iti = intlTelInput(document.querySelector("#phone-number"), {
      separateDialCode: true,
      utilsScript: utils,
    });
  },
  computed: {
    ...mapGetters(["vehicles"]),
  },
  methods: {
    ...mapActions(["addDrivers", "getDrivers"]),
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[a-zA-Z\s\b]*$/.test(char)) return true;
      else e.preventDefault();
    },
    validatePhoneNumber() {
      this.ErrorPhone = "";
      if (this.iti.isValidNumber()) {
        return true;
      } else {
        this.ErrorPhone = this.$t("valid_phone");
        return false;
      }
    },
    adddriver() {
      if (!this.validatePhoneNumber(this.number)) {
        this.ErrorPhone = this.$t("valid_phone");
        return;
      }
      this.isLoading = true;
      const newDriver = {
        name: this.fullname,
        address: this.address,
        email: this.email.toLowerCase(),
        phoneNumber: this.number,
        assignVehicle: this.vehicle.id
      };
      this.addDrivers(newDriver)
        .then((res) => {
          this.getDrivers();
          this.isLoading = false;
          this.onCancel();
          this.$emit("showSuccessPopup", {
            msg: this.$t("added_driver_mssg"),
            heading: this.$t("added_driver_heading"),
          });
        })
        .catch((error) => {
          console.error("Error adding driver:", error);
          this.isLoading = false;
          this.Errormssg = "Error adding driver. Please try again.";
        });
    },
  },
};
</script>

<style scoped>
label,
.form-control::placeholder {
  font-weight: 400;
  color: rgba(94, 106, 121, 1);
}

label {
  list-style: 15.6px;
  font-size: 12px;
}

.form-control::placeholder {
  font-size: 14px;
  line-height: 19.69px;
}

.btn-add {
  padding: 0;
  border-radius: 0;
  width: 100%;
  display: flex;
  justify-content: right;
}

.btn-add > button {
  border: none;
  border-radius: 16px;
  background-color: rgba(33, 62, 122, 1);
  color: rgba(247, 248, 249, 1);
  width: 84px;
  height: 44px;
  padding: 12px, 30px, 12px, 30px;
  font-size: 14px;
  font-weight: 600;
}

@media (max-width: 767px) {
  .driver_form {
    flex-direction: column;
  }
}

@media (min-width: 768px) {
  .modal-dialog {
    max-width: 500px !important;
  }

  .driver_form_input {
    width: 250px;
  }

  .driver_form {
    gap: 0.7rem;
  }
}
</style>
